module.exports = __webpack_public_path__ + "static/media/bg_bird.d040346b.png";